import React from "react";
import { Formik, Form } from "formik";
import l from "components/util/l";
import ViewField from "./CustomViews.sub.ViewField.view";

const custom_viewsView = ({
  presentationSettings = {},
  onSubmit,
}) => {
  return <div className="card">
    <div className="card-header">
      <h3 className="mb-0">{l("Editar secciones%PA075")}</h3>
    </div>
    <div
      className="card-body px-6 py-4"
    >
      <Formik
        initialValues={presentationSettings}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-capitalize"></th>
                  <th className="text-capitalize mr-2 w-100">{l("Nombre%GA074")}</th>
                  <th className="text-capitalize"></th>
                  <th className="text-capitalize"></th>
                </tr>
              </thead>
              <tbody>
                {
                  values?.views?.map((view, idx) => 
                    <ViewField
                      key={`field-view-${idx}`}
                      idx={idx}
                      view={view}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                  )
                }
              </tbody>
              <tfoot>
                <tr>
                  <td className="py-0" colSpan="4">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary text-left btn-block mt-2 mb-2 w-auto"
                      onClick={() => {
                        setFieldValue("views", [
                          ...values?.views ?? [],
                          {},
                        ]);
                        setFieldValue("selected_view", values?.views?.length ?? 0);
                      }}
                    >
                      + {l("Nueva vista%PA076")}
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>

            <button
              type="submit"
              className="btn btn-primary w-100 mt-4"
            >
              {l("Guardar%GA023")}
            </button>

          </Form>
        }
      </Formik>
    </div>
  </div>;
}

export default custom_viewsView;